// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'password-lock';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9.563 9.563H1.686A1.125 1.125 0 0 1 .563 8.437v-6.75A1.125 1.125 0 0 1 1.688.563h13.5a1.125 1.125 0 0 1 1.126 1.125v4.5m-.001 5.625h-4.5c-.622 0-1.126.503-1.126 1.124v3.376c0 .62.504 1.125 1.126 1.125h4.5c.62 0 1.125-.504 1.125-1.125v-3.375c0-.622-.504-1.126-1.125-1.126zm-2.25-3.375a2.25 2.25 0 0 0-2.25 2.25v1.124h4.5v-1.124a2.25 2.25 0 0 0-2.25-2.25z' />
    <path d='M8.438 5.344a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m4.5.563a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563m1.125 10.147a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563M3.938 5.344a.281.281 0 0 1 0-.563m0 .563a.281.281 0 0 0 0-.563' />
  </g>
);

export const viewBox = '0 0 18 18';
